import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Platform, MenuController, App} from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { Storage } from '@ionic/storage';
import { AlertController, Nav, ToastController, LoadingController } from 'ionic-angular';
import { SocialSharing } from '@ionic-native/social-sharing';

//@IonicPage()
@Component({
  selector: 'page-admission',
  templateUrl: 'admission.html',
})
export class AdmissionPage {

  SchoolData = {};
  TypeData = {};
  School = 'All';
  CommonTypeId = 'All';
  AllType = 'All';
  GWWType = 'All';
  GWEType = 'All';
  GEISType = 'All';
  EnquiryData:any;
  EnquiryData1:any;
  FUserId:any;
  UserRights:any;
  DataSearch:any;
  FilterOption='Date';
  Date:any;
  DisplayDate="";
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              private socialSharing: SocialSharing) {
    this.platform.ready().then(() => {

      this.Date = new Date();
      this.DisplayDate = this.Date.getDate()+"-"+this.monthNames[this.Date.getMonth()]+"-"+this.Date.getFullYear();
      this.Date= this.Date.toISOString();

      this.SchoolData={
        "All":0,
        "GWW":2,
        "GWE":3,
        "GEIS":1
      };

      this.TypeData={
        "All":0,
        "Admission":2,
        "EOD":"EOD",
      };

      Promise.all([this.storage.get('LoginData')]).then(values => {
        this.FUserId = values[0]['FUserId'];
        console.log(this.FUserId);
        this.get_user_rights(this.FUserId);
      });
    });
  }

  /*ionViewDidLoad() {
    this.platform.ready().then(() => {
      Promise.all([this.storage.get('LoginData')]).then(values => {
        this.FUserId = values[0]['FUserId'];
        console.log(this.FUserId);
        this.get_user_rights(this.FUserId);
      });
    });
    console.log('ionViewDidLoad AdmissionPage');
  }*/

  ionViewWillEnter() {
    this.platform.ready().then(() => {
      Promise.all([this.storage.get('LoginData')]).then(values => {
        this.FUserId = values[0]['FUserId'];
        console.log(this.FUserId);
        this.get_user_rights(this.FUserId);
      });
    });
    console.log('ionViewWillEnter PendingtaskPage');
  }

  loadvalues(FSchoolId,FTypeId,FUserId,Date){
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 5000);
    this.EnquiryData = [];
    console.log("FSchoolId",FSchoolId);
    console.log("FTypeId",FTypeId);
    this.service.httpcall('web_service/get_admissions?FSchoolId='+FSchoolId+'&FTypeId='+FTypeId+'&FUserId='+FUserId+'&Date='+Date).subscribe(data => {
      loading.dismiss();
      console.log(data);
      this.EnquiryData1 = data;
      this.EnquiryData = this.EnquiryData1;

      this.DataSearch="";
    })
  }

  add_filter(f){
    console.log(f);
    if(f=='All'){
      this.FilterOption='All';
      this.DisplayDate = "";
      this.loadvalues(this.SchoolData[this.School],this.TypeData[this.CommonTypeId],this.FUserId,this.DisplayDate);
    }else{
      this.FilterOption='Date';
      var Date1 = new Date(this.Date);
      console.log(Date1.getDate()+"-"+this.monthNames[Date1.getMonth()]+"-"+Date1.getFullYear());
      this.DisplayDate = Date1.getDate()+"-"+this.monthNames[Date1.getMonth()]+"-"+Date1.getFullYear();
      console.log("DisplayDate ",this.DisplayDate);
      this.loadvalues(this.SchoolData[this.School],this.TypeData[this.CommonTypeId],this.FUserId,this.DisplayDate);
      //this.datePicker.open();
      /*if(this.Date==""){
       this.Date = new Date();
       this.Date = this.Date.toISOString();
       }else {
       this.Date = new Date(this.Date);
       this.Date = this.Date.toISOString();
       }*/


      console.log('Date call');
    }

  }

  Prev(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) - 1);
    this.Date= this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  Next(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) + 1);
    this.Date= this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  searchData(ev: any) {
    // Reset items back to all of the items
    this.EnquiryData = this.EnquiryData1;
    // set val to the value of the searchbar
    let val = ev.target.value;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.EnquiryData = this.EnquiryData.filter((item) => {
        return (item.Description.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }

  }

  get_user_rights(FUserId){
    this.service.httpcall('web_service/get_users_rights?FUserId='+FUserId).subscribe(data => {
      console.log(data['RightsData']);
      this.UserRights = data['RightsData'];
      if(this.UserRights != undefined){
        console.log(this.School)
        this.loadvalues(this.SchoolData[this.School],this.TypeData[this.CommonTypeId],this.FUserId,this.DisplayDate);
      }
    })
  }

  active_tab(tab){
    console.log(tab);
    this.School = tab;
    this.CommonTypeId = 'All';
    this.AllType = 'All';
    this.GWWType = 'All';
    this.GWEType = 'All';
    this.GEISType = 'All';
    this.loadvalues(this.SchoolData[this.School],this.TypeData['All'],this.FUserId,this.DisplayDate);
    //get types for that particular school only [{Enquiry:true,Admission:false}]
  }

  active_All_sub_tab(sub_tab){
    console.log(sub_tab);
    this.AllType = sub_tab;
    this.CommonTypeId = sub_tab;
    this.loadvalues(this.SchoolData[this.School],this.TypeData[this.CommonTypeId],this.FUserId,this.DisplayDate);
  }

  active_GWW_sub_tab(sub_tab){
    console.log(sub_tab);
    this.GWWType = sub_tab;
    this.CommonTypeId = sub_tab;
    this.loadvalues(this.SchoolData[this.School],this.TypeData[this.CommonTypeId],this.FUserId,this.DisplayDate);
  }

  active_GWE_sub_tab(sub_tab){
    console.log(sub_tab);
    this.GWEType = sub_tab;
    this.CommonTypeId = sub_tab;
    this.loadvalues(this.SchoolData[this.School],this.TypeData[this.CommonTypeId],this.FUserId,this.DisplayDate);
  }

  active_GEIS_sub_tab(sub_tab){
    console.log(sub_tab);
    this.GEISType = sub_tab;
    this.CommonTypeId = sub_tab;
    this.loadvalues(this.SchoolData[this.School],this.TypeData[this.CommonTypeId],this.FUserId,this.DisplayDate);
  }

  doRefresh(refresher)
  {
    console.log('Begin async operation', refresher);

    this.loadvalues(this.SchoolData[this.School],this.TypeData[this.CommonTypeId],this.FUserId,this.DisplayDate);
    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }
  msg_Group(item){

    this.socialSharing.shareViaWhatsApp(item.Description, null, null);

  }

}



// WEBPACK FOOTER //
// ./src/pages/admission/admission.ts